import React, { useState } from 'react'
import { useFormik } from 'formik';
import { useLocation, useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import useEditFormData from '../../../Components/Hooks/useEditFormData';
import { BackButton, CancelButton, SubmitButton } from '../../../Components/Utils/Buttons';
import { NuTextArea } from '../../../Components/Utils/Input';

function EditForms() {
   const navigate = useNavigate();
    const location = useLocation();
    const data = location.state.data;
  
    
  const from = location.state.from;
  
  const {  editFormData } =
    useEditFormData
    (); 
     const [createNew, setCreateNew] = useState({
    
      Description: data?.Description  || "",
    Subject: data?.Subject  || "",
    TicketDate: data?.TicketDate  || "",
    ResponseDate: data?.ResponseDate  || "",
    Status: data?.Status  || "",
  
  
  
    
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
          }),
    onSubmit: async (value, { resetForm }) => {
      editFormData(
        `/employees/${data.employeeId}`,
        value,
        resetForm,
        from,
      );},
  });
  
  
  
  return (
    <div className=" w-full h-full py-2 px-4 ">
         <div className="flex justify-end w-full ">      
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-xl overflow-hidden mt-4">
        <div className=" w-full h-full flex justify-start content-start flex-wrap py-2 px-4  overflow-y-auto">
            <div className="w-full">
              <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#048178] decoration-2 underline-offset-4">
                Forms :
              </p>
            </div>
            
            <NuTextArea
                                          label="Description"
                                          placeholder="Description"
                                          formik={formik}
                                          name="Description"
                                          width="w-full md:w-1/2 "
                                          new_width="lg:w-2/3"
                                        />
           
           
            <div className="w-full  my-4 mt-8 ">
              <div className=" flex justify-end gap-4">
                <CancelButton
                  handleClick={() => {
                    navigate(-1);
                  }}
                />
                <SubmitButton />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default EditForms
